function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import classNames from 'classnames';
import style from './PaymentDetailItem.module.css';
export default function PaymentDetailItem(_ref) {
  var label = _ref.label,
    labelAnnotation = _ref.labelAnnotation,
    value = _ref.value,
    valueAnnotation = _ref.valueAnnotation,
    className = _ref.className,
    sameRowLabelAnnotation = _ref.sameRowLabelAnnotation;
  return /*#__PURE__*/React.createElement("section", {
    className: classNames(className, 'js-payment-details-item', style.item)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.column, _defineProperty({}, style.sameRowLabelAnnotation, sameRowLabelAnnotation))
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.label, 'js-label-text')
  }, label), labelAnnotation && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.annotation, 'js-label-annotation')
  }, labelAnnotation)), /*#__PURE__*/React.createElement("div", {
    className: style.column
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.value, 'js-value-text')
  }, value), valueAnnotation && /*#__PURE__*/React.createElement("div", {
    className: classNames(style.annotation, 'js-value-annotation')
  }, valueAnnotation)));
}